export const domElements = {
    iframe: '#leadin-iframe',
    subMenu: '.toplevel_page_leadin > ul',
    subMenuLinks: '.toplevel_page_leadin > ul a',
    subMenuButtons: '.toplevel_page_leadin > ul > li',
    deactivatePluginButton: '[data-slug="leadin"] .deactivate a',
    deactivateFeedbackForm: 'form.leadin-deactivate-form',
    deactivateFeedbackSubmit: 'button#leadin-feedback-submit',
    deactivateFeedbackSkip: 'button#leadin-feedback-skip',
    thickboxModalClose: '.leadin-modal-close',
    thickboxModalWindow: 'div#TB_window.thickbox-loading',
    thickboxModalContent: 'div#TB_ajaxContent.TB_modal',
    reviewBannerLeaveReviewLink: 'a#leave-review-button',
    reviewBannerDismissButton: 'a#dismiss-review-banner-button',
    leadinIframeContainer: 'leadin-iframe-container',
    leadinIframe: 'leadin-iframe',
    leadinIframeFallbackContainer: 'leadin-iframe-fallback-container',
};
